import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { ClipLoader } from "react-spinners";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "100px" }}>
        <ClipLoader color="#36d7b7" />
      </div>
    );
  }

  // إذا لا يوجد مستخدم، اذهب للـ Login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
